// src/pages/PrivacyPolicy.jsx
import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      color: '#e8e0d0',
      fontFamily: 'Georgia, serif',
      padding: '40px 20px',
    }}>
      <div style={{ maxWidth: '720px', margin: '0 auto' }}>

        {/* Başlık */}
        <div style={{ textAlign: 'center', marginBottom: '48px', borderBottom: '1px solid #333', paddingBottom: '32px' }}>
          <h1 style={{ fontSize: '1.4rem', letterSpacing: '0.2em', color: '#c9a84c', marginBottom: '8px' }}>
            RİSALE-İ NUR RADYO
          </h1>
          <h2 style={{ fontSize: '1rem', fontWeight: 'normal', opacity: 0.6, letterSpacing: '0.1em' }}>
            GİZLİLİK POLİTİKASI
          </h2>
          <p style={{ fontSize: '0.8rem', opacity: 0.4, marginTop: '12px' }}>
            Son güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>

        {/* Bölümler */}
        {[
          {
            title: '1. Genel Bilgi',
            content: `Risale-i Nur Radyo uygulaması, kullanıcılarına ücretsiz Kur'an ve Risale-i Nur okumaları yayını sunan bir internet radyosu uygulamasıdır. Gizliliğiniz bizim için önemlidir. Bu politika, uygulamamızın hangi verileri topladığını ve nasıl kullandığını açıklamaktadır.`
          },
          {
            title: '2. Toplanan Veriler',
            content: `Uygulamamız herhangi bir kişisel veri toplamamaktadır. Hesap oluşturma, kayıt veya oturum açma işlemi bulunmamaktadır. Kullanıcı adı, e-posta adresi veya kimlik bilgisi istenmemektedir.`
          },
          {
            title: '3. Anonim Kullanım Verisi',
            content: `Yalnızca anlık dinleyici sayısını göstermek amacıyla eş zamanlı bağlantı sayısı sayılmaktadır. Bu bilgi kimseye ait değildir, sunucuda kaydedilmemekte ve üçüncü taraflarla paylaşılmamaktadır.`
          },
          {
            title: '4. İnternet Bağlantısı',
            content: `Uygulama, canlı radyo yayınına bağlanmak için internet erişimi kullanır. Bu bağlantı yalnızca ses akışı içindir; başka hiçbir veri iletilmemektedir.`
          },
          {
            title: '5. Üçüncü Taraf Hizmetler',
            content: `Uygulama herhangi bir reklam ağı, analitik hizmet veya izleme aracı kullanmamaktadır. Google Analytics, Firebase veya benzeri bir platform entegre edilmemiştir.`
          },
          {
            title: '6. Çocukların Gizliliği',
            content: `Uygulama her yaştan kullanıcıya yöneliktir. Çocuklara ait kişisel veri toplanmamaktadır. Herhangi bir kayıt veya profil sistemi bulunmamaktadır.`
          },
          {
            title: '7. Değişiklikler',
            content: `Bu gizlilik politikası gerektiğinde güncellenebilir. Önemli bir değişiklik olması durumunda uygulama içinde bildirim yapılacaktır.`
          },
          {
            title: '8. İletişim',
            content: `Gizlilik politikamızla ilgili sorularınız için bize uygulama içindeki bağlantılar üzerinden ulaşabilirsiniz.`
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: '36px' }}>
            <h3 style={{
              fontSize: '0.85rem',
              letterSpacing: '0.12em',
              color: '#c9a84c',
              marginBottom: '12px',
              textTransform: 'uppercase',
            }}>
              {section.title}
            </h3>
            <p style={{
              fontSize: '0.95rem',
              lineHeight: '1.8',
              opacity: 0.75,
              margin: 0,
            }}>
              {section.content}
            </p>
          </div>
        ))}

        {/* Alt */}
        <div style={{
          textAlign: 'center',
          marginTop: '60px',
          paddingTop: '24px',
          borderTop: '1px solid #222',
          opacity: 0.35,
          fontSize: '0.75rem',
          letterSpacing: '0.08em',
        }}>
          © {new Date().getFullYear()} Risale-i Nur Radyo — Tüm hakları saklıdır.
        </div>

      </div>
    </div>
  );
}

export default PrivacyPolicy;